window.addEventListener('load', () => {
  const chat = document.querySelector('#ShopifyChat');
  if (!chat || !chat.shadowRoot) return;

  const shadowRoot = chat.shadowRoot;
  const isProductPage = document.body.classList.contains('template-product');

  const applyResponsiveButtonStyles = () => {
    const button = shadowRoot.querySelector('button[data-spec="toggle-button"]');
    const svg = button?.querySelector('svg');

    if (!button || !svg) return;

    if (window.matchMedia('(max-width: 768px)').matches) {
      button.style.width = '50px';
      button.style.height = '50px';
      svg.style.width = '40px';
      svg.style.height = '40px';
    } else {
      button.style.width = '';
      button.style.height = '';
      svg.style.width = '';
      svg.style.height = '';
    }
  };

  const applyChatUiStyles = () => {
    if (!isProductPage) return;

    const chatUI = shadowRoot.querySelector('#chat-ui');
    if (!chatUI) return;

    // if (window.matchMedia('(max-width: 768px)').matches) {
    //   chatUI.style.position = 'absolute';
    //   chatUI.style.top = '25rem';
    // } else {
    //   chatUI.style.position = '';
    //   chatUI.style.top = '';
    // }
  };

  const applyNotificationStyles = () => {
    const notification = shadowRoot.querySelector('.chat-notification');
    if (!notification) return;

    // notification.style.backgroundColor = '#808080';
    // notification.style.color = '#FFFFFF';
  };

  // Initial run
  applyResponsiveButtonStyles();
  applyChatUiStyles();
  applyNotificationStyles();

  // Observe Shadow DOM for dynamic changes
  const observer = new MutationObserver(() => {
    applyResponsiveButtonStyles();
    applyChatUiStyles();
    applyNotificationStyles();
  });

  observer.observe(shadowRoot, {
    childList: true,
    subtree: true
  });

  // Handle resize
  window.addEventListener('resize', () => {
    applyResponsiveButtonStyles();
    applyChatUiStyles();
  });
});
